var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-48804c38-a653-4a5b-b017-8c48cdb9df02",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m24.396,19.541c-.828,0-1.5-.671-1.5-1.5v-4.081c0-.829.672-1.5,1.5-1.5s1.5.671,1.5,1.5v4.081c0,.829-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.604,19.541c-.828,0-1.5-.671-1.5-1.5v-4.081c0-.829.672-1.5,1.5-1.5s1.5.671,1.5,1.5v4.081c0,.829-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.235,23.707c-.828,0-1.5-.671-1.5-1.5v-12.414c0-.829.672-1.5,1.5-1.5s1.5.671,1.5,1.5v12.414c0,.829-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.028,21.425c-.828,0-1.5-.671-1.5-1.5v-7.851c0-.829.672-1.5,1.5-1.5s1.5.671,1.5,1.5v7.851c0,.829-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.836,28.865c-.828,0-1.5-.671-1.5-1.5V4.635c0-.829.672-1.5,1.5-1.5s1.5.671,1.5,1.5v22.73c0,.829-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSaid);
export default __webpack_public_path__ + "static/media/UserSaid.dda4bf1cf8837e1337a18cd64df825b0.svg";
export { ForwardRef as ReactComponent };